import { get } from 'lodash';

import { TAppointment } from 'ui-model';

export default function getActionsSetting(appointment: TAppointment, settings: any) {
  // We first check for reminder.replies to check if it should allow the user to take reschedule and cancel actions
  const reminderRepliesFromMaster = get(settings, 'reminder.replies', false);

  // Get settings from both type and facility fields
  const reminderRepliesFromApptType = get(appointment, 'type.settings.reminder.replies', false);
  const reminderRepliesFromApptFacility = get(appointment, 'facility.settings.reminder.replies', false);

  // Check if it should override or not
  const overrideMasterForReminderRepliesFromApptType = get(
    settings,
    'settingsToOverrideFrom.appointmentTypes',
    [],
  ).includes('reminder.replies');
  const overrideMasterForReminderRepliesFromFacility = get(settings, 'settingsToOverrideFrom.facilities', []).includes(
    'reminder.replies',
  );

  const getReminderRepliesSetting = () => {
    if (overrideMasterForReminderRepliesFromApptType) return reminderRepliesFromApptType;
    if (overrideMasterForReminderRepliesFromFacility) return reminderRepliesFromApptFacility;
    return reminderRepliesFromMaster;
  };

  // Then we check for reminder.allowSelfReschedule to check if it should allow the user to take the actions as well
  const allowSelfRescheduleFromMaster = get(settings, 'reminder.allowSelfReschedule', false);

  // Get settings from both type and facility fields
  const allowSelfRescheduleFromApptType = get(appointment, 'type.settings.reminder.allowSelfReschedule', false);
  const allowSelfRescheduleFromApptFacility = get(appointment, 'facility.settings.reminder.allowSelfReschedule', false);

  // Check if it should override or not
  const overrideMasterForAllowSelfRescheduleFromApptType = get(
    settings,
    'settingsToOverrideFrom.appointmentTypes',
    [],
  ).includes('reminder.allowSelfReschedule');
  const overrideMasterForAllowSelfRescheduleFromFacility = get(
    settings,
    'settingsToOverrideFrom.facilities',
    [],
  ).includes('reminder.allowSelfReschedule');

  const getReminderAllowSelfRescheduleSetting = () => {
    if (overrideMasterForAllowSelfRescheduleFromApptType) return allowSelfRescheduleFromApptType;
    if (overrideMasterForAllowSelfRescheduleFromFacility) return allowSelfRescheduleFromApptFacility;
    return allowSelfRescheduleFromMaster;
  };

  let cancelAllowed = false;
  let rescheduleAllowed = false;
  if (getReminderRepliesSetting() === 'allowed') {
    cancelAllowed = true;
    rescheduleAllowed = getReminderAllowSelfRescheduleSetting();
  } else {
    // This covers both "confirmationOnly" and "none" cases
    cancelAllowed = false;
    rescheduleAllowed = false;
  }

  return { cancelAllowed, rescheduleAllowed };
}
